/**
 * 常量状态
 */
export enum STATUS_CONSTANT {
  STATUS_01,
  STATUS_02,
  STATUS_03,
  STATUS_04,
  STATUS_05,
  STATUS_06,
  STATUS_07,
  STATUS_08,
  STATUS_09,
  STATUS_10
}

/**
 * 调用button需要传入数据
 */
export interface IButtonOptions {
  width: number
  height: number
  color: string
  text: string
  background: string
}
